import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import { historyRepository } from '@shared/domain/router/router.repository';
import { SIDEBAR_ROUTES_LIST } from '@shared/infrastructure/router/paths';

export const Sidebar = () => {
  return (
    <List
      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      component='nav'
      aria-labelledby='tab-list-drawer'
      role='menubar'
    >
      {SIDEBAR_ROUTES_LIST.map(({ id, path, label, Icon }) => (
        <ListItemButton
          key={id}
          onClick={() => historyRepository.push(path)}
          role='menuitem'
        >
          <ListItemIcon>
            <Icon />
          </ListItemIcon>
          <ListItemText primary={label} />
        </ListItemButton>
      ))}
    </List>
  );
};
